import EChartsPanel from "./e-charts/EChartsPanel";

const EDataChartsTab = () => <EChartsPanel />;

export default EDataChartsTab;
